import { lionGrid, lionRuns, type LionPose } from "./lion-sprites";
import { SignOutButton } from "./SignOut";

// The BuildLab lion (decision 60), drawn as crisp SVG pixels. `size` is the height in CSS pixels;
// keep it a multiple of the sprite's height (26, or 17 for the head) so every pixel stays square
// and sharp. Decorative unless given a label.

export function Lion({ pose = "stand", size = 104, label, className, bob }: { pose?: LionPose; size?: number; label?: string; className?: string; bob?: boolean }) {
  const grid = lionGrid(pose);
  const w = grid[0]!.length;
  const h = grid.length;
  return (
    <svg
      className={`lion${bob ? " lion-bob" : ""}${className ? ` ${className}` : ""}`}
      viewBox={`0 0 ${w} ${h}`}
      width={(size * w) / h}
      height={size}
      shapeRendering="crispEdges"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      {lionRuns(pose).map((r, i) => (
        <rect key={i} x={r.x} y={r.y} width={r.w} height={1} fill={r.c} />
      ))}
    </svg>
  );
}

/** A whole-screen wait with the thinking lion (app start, sign-in, opening a project). */
export function LoadingScreen({ text }: { text: string }) {
  return (
    <main className="lion-screen" role="status">
      <Lion pose="think" size={104} bob label="Roary, thinking" />
      <p className="loading-text">{text}</p>
    </main>
  );
}

/** A whole-screen error with the lion, so a failure never looks like a blank page. */
export function ErrorScreen({ message, onHome }: { message: string; onHome?: () => void }) {
  return (
    <main className="lion-screen page-error" role="alert">
      <Lion pose="think" size={104} label="Roary, sorry, something went wrong" />
      <p className="error-text">{message}</p>
      <button type="button" className="outline" onClick={() => location.reload()}>
        Try again
      </button>
      {onHome && (
        <button type="button" className="outline" onClick={onHome}>
          Home
        </button>
      )}
      {/* Signed in with the wrong account (or BuildLab isn't open to students yet): a way out. */}
      <SignOutButton className="linklike small" />
    </main>
  );
}
